import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", href: "/" },
  { label: "热门推荐", href: "/#hot" },
  { label: "分类浏览", href: "/#categories" },
  { label: "最新资讯", href: "/#news" },
  { label: "关于我们", href: "/about" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            aria-label="51漫画首页"
          >
            <span className={`font-heading text-xl md:text-2xl font-black tracking-tight transition-colors duration-300 ${
              isScrolled || !isHome ? "text-primary-500" : "text-background-50"
            }`}>
              51<span className="text-accent-500">漫画</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.href
                    ? `${isScrolled || !isHome ? "text-primary-500" : "text-accent-400"}`
                    : `${isScrolled || !isHome ? "text-foreground-700 hover:text-primary-500" : "text-background-50/80 hover:text-background-50"}`
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/#download"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap ${
                isScrolled || !isHome
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-background-50/20 text-background-50 hover:bg-background-50/30 backdrop-blur-sm border border-background-50/30"
              }`}
            >
              <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
              下载APP
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200 ${
              isScrolled || !isHome ? "text-foreground-700 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
            }`}
            aria-label="切换菜单"
            aria-expanded={isMobileMenuOpen}
          >
            <i className={`${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-xl w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50">
            <div className="flex flex-col py-4 px-4 gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    location.pathname === link.href
                      ? "bg-primary-50 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/#download"
                className="mt-2 px-4 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 text-center hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-download-line w-4 h-4 mr-2 inline-flex items-center justify-center"></i>
                下载APP
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}